import React from 'react';
import styled from 'styled-components';

const HeaderSpaceWrapper = () => {
  return <HeaderSpaceWrapperContainer />;
};

export default HeaderSpaceWrapper;

const HeaderSpaceWrapperContainer = styled.div`
  height: 72px;
  @media screen and (max-width: 1439px) and (min-width: 905px) {
    height: 60px;
  }
  @media screen and (max-width: 904px) and (min-width: 600px) {
    height: 52px;
  }
  @media screen and (max-width: 599px) {
    height: 44px;
  }
`;
